import script from "./communityDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./communityDetail.vue?vue&type=script&lang=ts&setup=true"

import "./communityDetail.vue?vue&type=style&index=0&id=068bacf6&lang=less"

const __exports__ = script;

export default __exports__